<template>
  <q-dialog :model-value="modelValue" @update:model-value="emit('update:modelValue', $event)">
    <q-card class="feedback-card">
      <div class="feedback-header flex row items-center justify-between q-py-md q-px-lg">
        <div class="flex row items-center">
          <q-icon name="o_forum" size="1.3rem" color="white" />
          <span class="feedback-title q-ml-sm">Enviar feedback</span>
        </div>
        <q-btn flat round dense icon="close" color="white" v-close-popup />
      </div>

      <q-card-section class="q-px-lg q-pt-lg q-pb-none">
        <p class="feedback-subtitle">
          Sua opinião nos ajuda a melhorar. Conte pra gente o que achou, o que
          poderia ser diferente, ou relate qualquer problema que encontrou.
        </p>
      </q-card-section>

      <q-card-section class="q-px-lg q-pb-lg">
        <q-form @submit.prevent="submitFeedback" class="column q-gutter-md">
          <q-input
            outlined
            dense
            v-model="form.name"
            label="Nome (opcional)"
            maxlength="120"
          />

          <q-input
            outlined
            dense
            v-model="form.email"
            label="E-mail (opcional)"
            type="email"
            maxlength="160"
            :rules="[
              (val) =>
                !val ||
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val) ||
                'E-mail inválido',
            ]"
          />

          <q-input
            outlined
            v-model="form.message"
            label="Seu feedback *"
            type="textarea"
            rows="6"
            maxlength="2000"
            :rules="[
              (val) => (!!val && val.trim().length > 0) || 'Campo obrigatório',
            ]"
          />

          <div class="flex justify-end q-mt-sm">
            <q-btn
              type="submit"
              unelevated
              rounded
              no-caps
              class="feedback-submit-btn"
              :loading="loading"
              label="Enviar feedback"
            />
          </div>
        </q-form>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { reactive, ref } from "vue";
import { useQuasar } from "quasar";
import FeedbackServices from "@/services/FeedbackServices";

const props = defineProps({
  modelValue: { type: Boolean, default: false },
});
const emit = defineEmits(["update:modelValue"]);

const $q = useQuasar();
const _feedbackServices = new FeedbackServices();

const loading = ref(false);
const form = reactive({
  name: "",
  email: "",
  message: "",
});

async function submitFeedback() {
  if (!form.message || !form.message.trim()) {
    $q.notify({
      message: "Por favor, escreva seu feedback antes de enviar.",
      color: "red-8",
      position: "top",
    });
    return;
  }

  loading.value = true;
  try {
    await _feedbackServices.send({
      name: form.name || null,
      email: form.email || null,
      message: form.message,
    });

    $q.notify({
      message: "Feedback enviado com sucesso. Obrigado!",
      color: "positive",
      position: "top",
    });

    form.name = "";
    form.email = "";
    form.message = "";
    emit("update:modelValue", false);
  } catch (error) {
    const message =
      error?.response?.data || "Não foi possível enviar seu feedback. Tente novamente.";
    $q.notify({
      message,
      color: "red-8",
      position: "top",
    });
  } finally {
    loading.value = false;
  }
}
</script>

<style lang="scss" scoped>
.feedback-card {
  width: 100%;
  max-width: 560px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(20, 20, 43, 0.12);
}

.feedback-header {
  background: linear-gradient(135deg, #312a63 0%, #362f78 55%, #402a6e 100%);
}

.feedback-title {
  color: #ffffff;
  font-weight: 700;
  font-size: 1.05rem;
}

.feedback-subtitle {
  font-size: 0.85rem;
  color: #6b7280;
  margin: 0;
}

.feedback-submit-btn {
  background: linear-gradient(135deg, #4f46e5, #6d28d9);
  color: #ffffff;
  padding: 0.5rem 1.6rem;
  font-weight: 600;
}
</style>
